"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BOOSTER_USER_OFFERS_ECRED = exports.BOOSTER_USER_OFFERS_LIMPA_NOME = exports.BOOSTER_USER_SCORE = exports.BOOSTER_USER_DEBTS = exports.BOOSTER_USER_CREDIT = exports.BOOSTER_USER_COMPANY = exports.BOOSTER_USER_MOTIVATION = exports.BOOSTER_USER_ADVERTISING = exports.BOOSTER_USER_DATA_CREDIT = exports.BOOSTER_USER_SIGNUP = exports.BOOSTER_USER = exports.BOOSTER_PAGEVIEW = exports.BOOSTER_GA = exports.BOOSTER_GTM = exports.BoosterTypes = exports.BoosterEmit = exports.BoosterInitialize = exports.BoosterReady = void 0;

var _booster = require("./booster");

var types = _interopRequireWildcard(require("./types"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BoosterReady = _booster.ready;
exports.BoosterReady = BoosterReady;
var BoosterInitialize = _booster.initialize;
exports.BoosterInitialize = BoosterInitialize;
var BoosterEmit = _booster.emit;
exports.BoosterEmit = BoosterEmit;
var BoosterTypes = types;
exports.BoosterTypes = BoosterTypes;
var BOOSTER_GTM = types.BOOSTER_GTM;
exports.BOOSTER_GTM = BOOSTER_GTM;
var BOOSTER_GA = types.BOOSTER_GA;
exports.BOOSTER_GA = BOOSTER_GA;
var BOOSTER_PAGEVIEW = types.BOOSTER_PAGEVIEW;
exports.BOOSTER_PAGEVIEW = BOOSTER_PAGEVIEW;
var BOOSTER_USER = types.BOOSTER_USER;
exports.BOOSTER_USER = BOOSTER_USER;
var BOOSTER_USER_SIGNUP = types.BOOSTER_USER_SIGNUP;
exports.BOOSTER_USER_SIGNUP = BOOSTER_USER_SIGNUP;
var BOOSTER_USER_DATA_CREDIT = types.BOOSTER_USER_DATA_CREDIT;
exports.BOOSTER_USER_DATA_CREDIT = BOOSTER_USER_DATA_CREDIT;
var BOOSTER_USER_ADVERTISING = types.BOOSTER_USER_ADVERTISING;
exports.BOOSTER_USER_ADVERTISING = BOOSTER_USER_ADVERTISING;
var BOOSTER_USER_MOTIVATION = types.BOOSTER_USER_MOTIVATION;
exports.BOOSTER_USER_MOTIVATION = BOOSTER_USER_MOTIVATION;
var BOOSTER_USER_COMPANY = types.BOOSTER_USER_COMPANY;
exports.BOOSTER_USER_COMPANY = BOOSTER_USER_COMPANY;
var BOOSTER_USER_CREDIT = types.BOOSTER_USER_CREDIT;
exports.BOOSTER_USER_CREDIT = BOOSTER_USER_CREDIT;
var BOOSTER_USER_DEBTS = types.BOOSTER_USER_DEBTS;
exports.BOOSTER_USER_DEBTS = BOOSTER_USER_DEBTS;
var BOOSTER_USER_SCORE = types.BOOSTER_USER_SCORE;
exports.BOOSTER_USER_SCORE = BOOSTER_USER_SCORE;
var BOOSTER_USER_OFFERS_LIMPA_NOME = types.BOOSTER_USER_OFFERS_LIMPA_NOME;
exports.BOOSTER_USER_OFFERS_LIMPA_NOME = BOOSTER_USER_OFFERS_LIMPA_NOME;
var BOOSTER_USER_OFFERS_ECRED = types.BOOSTER_USER_OFFERS_ECRED;
exports.BOOSTER_USER_OFFERS_ECRED = BOOSTER_USER_OFFERS_ECRED;
var _default = {
  ready: _booster.ready,
  initialize: _booster.initialize,
  emit: _booster.emit
};
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/booster/build/index.js
// module id = 65
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38